<template>
  <div
    class="dateFare"
    :class="classes"
    @click="date.amount && isEnabled && $emit('select')"
  >
    <div
      v-if="isEnabled"
      class="dateFare__value"
    >
      {{ date.amount ? date.amount.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : $t('not_available') }}
    </div>
    <div
      v-if="isEnabled"
      class="dateFare__currency"
    >
      {{ date.amount ? date.currency : '' }}
    </div>
    <div
      v-if="date.amount && isEnabled && date.best_price"
      v-tooltip="$t('best_price')"
      class="dateFare__icon"
    >
      <i class="fas fa-star"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      required: true,
      type: Object,
      default: () => {}
    },
    isEnabled: {
      required: true,
      type: Boolean
    },
    classes: {
      required: true,
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="sass" scoped>
.dateFare
  display: flex
  justify-content: center
  align-items: center
  position: relative
  flex: 1
  padding: 0 .25rem
  box-shadow: 0 0 0 1px var(--color-overlay-05), inset 0 0 3rem var(--color-overlay-05)
  display: flex
  flex-wrap: wrap
  transition: background-color .2s ease, color .2s ease
  cursor: pointer
  border-radius: var(--b-radius-sm)
  &.--active
    background-color: var(--color-primary)
    color: var(--color-onPrimary)
    box-shadow: var(--z-1)
    z-index: 100
    position: relative
    &.--disabled
      background-color: var(--color-primary)
  &.--disabled
    background-color: var(--color-overlay-10)
    cursor: not-allowed
    text-align: center
    justify-content: center
    font-size: var(--font-size-sm)
    .dateFare__fareCurrency
      display: none
    &.--lower
      border-bottom: 0
  &:hover:not(.--active):hover:not(.--disabled)
    background-color: var(--color-surface)
.dateFare__currency
    font-size: var(--font-size-sm)
    margin-left: .5rem
.dateFare__icon
  position: absolute
  top: 0.15rem
  right: 0.25rem
  font-size: var(--font-size-xs)
</style>
